import { Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { Options } from '@checkout/const';
import { CheckoutActions, CheckoutApiService } from '@checkout/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class OptionsEffects {
  loadOptions$: Observable<CheckoutActions.LoadOptionsSuccess | CheckoutActions.LoadOptionsFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.LOAD_OPTIONS),
      switchMap(() =>
        combineLatest({
          cartId: this.activeCartService.getActiveCartId(),
        }).pipe(take(1)),
      ),
      filter(({ cartId }) => !!cartId),
      switchMap(({ cartId }: { cartId: string }) =>
        this.checkoutApiService.loadOptions(cartId).pipe(
          map((data: Options) => new CheckoutActions.LoadOptionsSuccess(data)),
          catchError((error) => of(new CheckoutActions.LoadOptionsFail(error))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private checkoutApiService: CheckoutApiService,
    private activeCartService: ActiveCartService,
  ) {}
}
